import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatAccordion } from '@angular/material/expansion';
import { ConsoleHomeService } from 'src/app/core/services/console-home.service';
import { UtilityService } from 'src/app/core/services/utility.service';
import { SwitchWorkspaceWarningPopupComponent } from '../switch-workspace-warning-popup/switch-workspace-warning-popup.component';
import { path } from 'src/environments/config';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'vcp-select-workspace',
  templateUrl: './select-workspace.component.html',
  styleUrls: ['./select-workspace.component.scss'],
})
export class SelectWorkspaceComponent implements OnInit {
  @ViewChild(MatAccordion) accordion: MatAccordion;
  selectedWorkspace;
  account;
  searchValue;
  btnLoader = false;
  constructor(
    public dialogRef: MatDialogRef<SelectWorkspaceComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private readonly us: UtilityService,
    private readonly chs: ConsoleHomeService,
    private dialog: MatDialog,
  ) {
    this.getDefaultWorkspace();
  }

  ngOnInit(): void {}

  applyFilter(event) {
    this.accordion.openAll();
    this.searchValue = (event.target as HTMLInputElement).value;
  }

  selectWorkspace(account, workspace) {
    let dw = this.us.getWorkspaceAccessLevel()
    if (dw) {
      if (dw !== workspace.workspaceHierarchy) {
        this.openWarningPopup(account, workspace);
        this.dialogRef.close();
      }
      else{
        this.onNoClick();
      }
    }
  }

  getDefaultWorkspace() {
    const dw = this.us.getWorkspaceAccessLevel();
    if (!dw) return;
    if (this.data.list && this.data.list.length > 0) {
      for (let i = 0; i < this.data.list.length; i++) {
        let workspace = this.data.list[i].workspaces.find(
          (ele) => ele.workspaceHierarchy == dw
        );
        if (workspace) {
          this.account = this.data.list[i];
          this.selectedWorkspace = workspace;
          break;
        }else{
          this.account = this.data.list[0];
          this.selectedWorkspace = this.data.list[0].workspaces[0];
        }
      }
    }
  }
  //

  openWarningPopup(account , workspace){
    const dialogRef = this.dialog.open(SwitchWorkspaceWarningPopupComponent, {
      width: '360px',
      panelClass: ['switch-modal'],
      data: [],
    });
    dialogRef.afterClosed().subscribe((result) => {
    if(result){
      let msg = {
        id: this.selectedWorkspace.workspaceHierarchy,
        env: path
      }
      this.selectedWorkspace = workspace;
      this.account = account;
      this.us.broadcast(msg);
      this.setDefaultWorkspace();
    }
    });
  }

  setDefaultWorkspace() {
    if (this.btnLoader) return;
    let dw;
    if (this.us.getWorkspaceAccessLevel()) {
      dw = this.us.getWorkspaceAccessLevel();
      if (dw === this.selectedWorkspace.workspaceHierarchy) {
        this.onNoClick();
        return;
      }
    }
    const preferences = [
      {
        name: 'ACCESS_LEVEL',
        value: this.selectedWorkspace.workspaceHierarchy,
      }

    ];
    this.btnLoader = true;
    this.chs.savePreference(preferences).subscribe((res) => {
      this.btnLoader = false;
      if (res && res.code === 'success') {
        this.us.setCookie('WORKSPACE_NAME',this.selectedWorkspace.workspaceName);
        this.us.setCookie('WORKSPACE_ID',this.selectedWorkspace.workspaceId);
        this.us.setCookie('DEFAULT_ACCOUNT_USER_ROLE',this.selectedWorkspace.userRole);
        this.us.setCookie('DEFAULT_ACCOUNT_NAME',this.selectedWorkspace.accountName);
        this.us.setCookie('DEFAULT_ACCOUNT_ID',this.selectedWorkspace.accountId);
        this.us.setCookie('DEFAULT_ACCOUNT_HIERARCHY',this.selectedWorkspace.accountHierarchy);
        this.chs.setConsoleSubject({
          action: 'refresh',
          workspace: this.selectedWorkspace,
        });
        this.dialogRef.close(this.selectedWorkspace);
      }
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
